import React from "react";

export default function PageContainer({ children }) {
    return (
        <section className="page">
            <div className="page__container">{children}</div>
        </section>
    );
}
